var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.979,
    height: 11.979,
    viewBox: "0 0 11.979 11.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#74b1ee;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.909,4.92H7.273a.214.214,0,0,1-.214-.214V1.07a1.07,1.07,0,0,0-2.139,0V4.706a.214.214,0,0,1-.214.214H1.07a1.07,1.07,0,0,0,0,2.139H4.706a.214.214,0,0,1,.214.214v3.636a1.07,1.07,0,1,0,2.139,0V7.273a.214.214,0,0,1,.214-.214h3.636a1.07,1.07,0,1,0,0-2.139Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon2);
export default __webpack_public_path__ + "static/media/plus-icon-2.ee98d26180068393415b3637c8510443.svg";
export { ForwardRef as ReactComponent };